const parcoursI18n = {
  "fr": {
    "parcours": {
      "title": "Un parcours en 5 étapes !",
      "steps": {
        "1": {
          "title": "Choisissez vos écrans et pièces",
          "body": "Parcourez notre catalogue, sélectionnez vos références (modèles, états, quantités) et ajoutez-les au panier. L'interface est pensée pour aller vite et éviter les erreurs.",
          "cta": "Choisir mes pièces"
        },
        "2": {
          "title": "Confirmez votre panier",
          "body": "Vérifiez votre récapitulatif et validez en un clic : vous obtenez une estimation instantanée et transparente, basée sur nos prix de rachat à jour."
        },
        "3": {
          "title": "Expédiez vos articles",
          "body": "Imprimez le bordereau, emballez selon nos conseils et déposez le colis chez le transporteur indiqué. Le suivi d’acheminement est disponible dans votre espace."
        },
        "4": {
          "title": "Contrôle des pièces",
          "body": "À réception, nos techniciens contrôlent chaque référence, valident l’état et publient un rapport détaillé (conforme / non conforme) directement dans votre tableau de bord."
        },
        "5": {
          "title": "Recevez votre paiement",
          "body": "Une fois le contrôle validé, nous déclenchons immédiatement le virement sur votre IBAN. Pas de frais cachés, pas d’attente."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Avec ",
          "bold1": "123Back",
          "s2": ", vous profitez d’un parcours de rachat simple, fluide et totalement traçable. La sélection des pièces, l’estimation immédiate, l’envoi sécurisé et le contrôle expert s’enchaînent dans un processus clair, suivi en temps réel dans votre espace personnel. Notre priorité est de vous faire ",
          "bold2": "gagner du temps",
          "s3": " et de ",
          "bold3": "sécuriser vos marges",
          "s4": " en prenant en charge la logistique, le reporting et le paiement, tout en vous laissant le contrôle de vos volumes et de vos prix."
        },
        "p2": {
          "s1": "Vous bénéficiez de ",
          "bold1": "prix justes",
          "s2": ", d’un ",
          "bold2": "paiement rapide",
          "s3": " et d’une",
          "bold3": " expérience transparente",
          "s4": ", exactement ce que l’on attend d’un partenaire fiable et professionnel."
        }
      }
    }
  },
  "en": {
    "parcours": {
      "title": "A 5-step journey!",
      "steps": {
        "1": {
          "title": "Choose your screens and parts",
          "body": "Browse our catalog, select your references (models, conditions, quantities) and add them to your cart. The interface is designed to be fast and prevent errors.",
          "cta": "Choose my parts"
        },
        "2": {
          "title": "Confirm your cart",
          "body": "Check your summary and validate in one click: you get an instant, transparent estimate based on our up-to-date buyback prices."
        },
        "3": {
          "title": "Ship your items",
          "body": "Print the label, pack following our tips, and drop the parcel at the indicated carrier. Tracking is available in your account."
        },
        "4": {
          "title": "Parts inspection",
          "body": "On arrival, our technicians check each reference, validate its condition, and publish a detailed report (compliant/non-compliant) directly in your dashboard."
        },
        "5": {
          "title": "Receive your payment",
          "body": "Once the inspection is approved, we immediately trigger the bank transfer to your IBAN. No hidden fees, no waiting."
        }
      },
      "bottom": {
        "p1": {
          "s1": "With ",
          "bold1": "123Back",
          "s2": ", you benefit from a simple, smooth, and fully traceable buyback journey. Selecting parts, instant estimate, secure shipping, and expert checks follow one another in a clear process, tracked in real time in your account. Our priority is to help you ",
          "bold2": "save time",
          "s3": " and ",
          "bold3": "secure your margins",
          "s4": " by handling logistics, reporting, and payment, while leaving you in control of your volumes and pricing."
        },
        "p2": {
          "s1": "You benefit from ",
          "bold1": "fair prices",
          "s2": ", ",
          "bold2": "fast payment",
          "s3": " and a",
          "bold3": " transparent experience",
          "s4": ", exactly what you expect from a reliable, professional partner."
        }
      }
    }
  },
  "pl": {
    "parcours": {
      "title": "5-etapowy proces!",
      "steps": {
        "1": {
          "title": "Wybierz ekrany i części",
          "body": "Przeglądaj katalog, wybierz referencje (modele, stan, ilości) i dodaj je do koszyka. Interfejs zaprojektowano tak, by działał szybko i ograniczał błędy.",
          "cta": "Wybierz części"
        },
        "2": {
          "title": "Potwierdź koszyk",
          "body": "Sprawdź podsumowanie i zatwierdź jednym kliknięciem — otrzymasz natychmiastową, przejrzystą wycenę opartą na aktualnych cenach odkupu."
        },
        "3": {
          "title": "Wyślij przedmioty",
          "body": "Wydrukuj etykietę, zapakuj zgodnie z naszymi wskazówkami i nadaj paczkę u wskazanego przewoźnika. Śledzenie przesyłki jest dostępne w Twoim koncie."
        },
        "4": {
          "title": "Kontrola części",
          "body": "Po dostawie nasi technicy sprawdzają każdą pozycję, potwierdzają stan i publikują szczegółowy raport (zgodny/niezgodny) bezpośrednio w Twoim panelu."
        },
        "5": {
          "title": "Odbierz płatność",
          "body": "Po pozytywnej weryfikacji niezwłocznie zlecamy przelew na Twój IBAN. Bez ukrytych opłat, bez czekania."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Z ",
          "bold1": "123Back",
          "s2": " korzystasz z prostego, płynnego i w pełni śledzalnego procesu odkupu. Wybór części, natychmiastowa wycena, bezpieczna wysyłka i ekspercka kontrola następują po sobie w przejrzystym procesie, śledzonym w czasie rzeczywistym w Twoim koncie. Naszym priorytetem jest, abyś ",
          "bold2": "oszczędzał czas",
          "s3": " i ",
          "bold3": "chronił marże",
          "s4": " — przejmujemy logistykę, raportowanie i płatności, pozostawiając Ci kontrolę nad wolumenem i cenami."
        },
        "p2": {
          "s1": "Zyskujesz ",
          "bold1": "uczciwe ceny",
          "s2": ", ",
          "bold2": "szybką płatność",
          "s3": " oraz",
          "bold3": " przejrzyste doświadczenie",
          "s4": " — dokładnie to, czego oczekujesz od rzetelnego, profesjonalnego partnera."
        }
      }
    }
  },
  "es": {
    "parcours": {
      "title": "¡Un recorrido en 5 pasos!",
      "steps": {
        "1": {
          "title": "Elige tus pantallas y piezas",
          "body": "Explora nuestro catálogo, selecciona tus referencias (modelos, estados, cantidades) y añádelas al carrito. La interfaz está diseñada para ser rápida y evitar errores.",
          "cta": "Elegir mis piezas"
        },
        "2": {
          "title": "Confirma tu carrito",
          "body": "Revisa tu resumen y valida en un clic: obtienes una estimación instantánea y transparente basada en nuestros precios de recompra actualizados."
        },
        "3": {
          "title": "Envía tus artículos",
          "body": "Imprime la etiqueta, embala siguiendo nuestros consejos y deposita el paquete en el transportista indicado. El seguimiento del envío está disponible en tu espacio personal."
        },
        "4": {
          "title": "Control de las piezas",
          "body": "A la recepción, nuestros técnicos revisan cada referencia, validan su estado y publican un informe detallado (conforme / no conforme) directamente en tu panel."
        },
        "5": {
          "title": "Recibe tu pago",
          "body": "Una vez validado el control, realizamos inmediatamente la transferencia a tu IBAN. Sin costes ocultos, sin esperas."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Con ",
          "bold1": "123Back",
          "s2": ", disfrutas de un proceso de recompra simple, fluido y totalmente trazable. La selección de piezas, la estimación inmediata, el envío seguro y el control experto se encadenan en un proceso claro, seguido en tiempo real desde tu espacio personal. Nuestra prioridad es ayudarte a ",
          "bold2": "ganar tiempo",
          "s3": " y a ",
          "bold3": "asegurar tus márgenes",
          "s4": " encargándonos de la logística, los informes y el pago, mientras sigues controlando tus volúmenes y precios."
        },
        "p2": {
          "s1": "Te beneficias de ",
          "bold1": "precios justos",
          "s2": ", un ",
          "bold2": "pago rápido",
          "s3": " y una",
          "bold3": " experiencia transparente",
          "s4": ", exactamente lo que se espera de un socio fiable y profesional."
        }
      }
    }
  },
  "it": {
    "parcours": {
      "title": "Un viaggio a 5 passi!",
      "steps": {
        "1": {
          "title": "Scegli i tuoi schermi e parti",
          "body": "Sfoglia il nostro catalogo, seleziona i tuoi riferimenti (modelli, condizioni, quantità) e aggiungili al carrello. L'interfaccia è progettata per essere veloce e prevenire errori.",
          "cta": "Scegli le mie parti"
        },
        "2": {
          "title": "Conferma il tuo carrello",
          "body": "Controlla il tuo riassunto e convalida in un clic: ottieni una stima istantanea e trasparente in base ai nostri prezzi di acquisto aggiornati."
        },
        "3": {
          "title": "Spedisci i tuoi articoli",
          "body": "Stampare l'etichetta, imballare seguendo i nostri consigli, e lasciare il pacco al vettore indicato. Il monitoraggio è disponibile nel tuo account."
        },
        "4": {
          "title": "Ispezione delle parti",
          "body": "All'arrivo, i nostri tecnici controllano ogni riferimento, convalidano la sua condizione e pubblicano un report dettagliato (conforme/non conforme) direttamente nella vostra dashboard."
        },
        "5": {
          "title": "Ricevi il tuo pagamento",
          "body": "Una volta approvata l'ispezione, si attiva immediatamente il trasferimento bancario al vostro IBAN. Niente tasse nascoste, niente attesa."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Con",
          "bold1": "123Back",
          "s2": ", si beneficia di un viaggio di buyback semplice, liscio e completamente tracciabile. Selezione di parti, stima istantanea, spedizione sicura e controlli esperti si seguono in un processo chiaro, tracciato in tempo reale nel tuo account. La nostra priorità è aiutarvi",
          "bold2": "risparmiare tempo",
          "s3": "e",
          "bold3": "proteggere i vostri margini",
          "s4": "maneggiando logistica, reportistica e pagamento, lasciandoti sotto controllo dei tuoi volumi e prezzi."
        },
        "p2": {
          "s1": "Lei beneficia di",
          "bold1": "prezzi giusti",
          "s2": ", ",
          "bold2": "pagamento veloce",
          "s3": "e",
          "bold3": "esperienza trasparente",
          "s4": ", esattamente quello che ti aspetti da un partner affidabile e professionale."
        }
      }
    }
  },
  "de": {
    "parcours": {
      "title": "Eine 5-stufige Reise!",
      "steps": {
        "1": {
          "title": "Wählen Sie Ihre Bildschirme und Teile",
          "body": "Durchsuchen Sie unseren Katalog, wählen Sie Ihre Referenzen (Modelle, Bedingungen, Mengen) und fügen Sie sie Ihrem Warenkorb hinzu. Die Schnittstelle ist so konzipiert, dass sie schnell ist und Fehler verhindert.",
          "cta": "Wählen Sie meine Teile"
        },
        "2": {
          "title": "Bestätigen Sie Ihren Wagen",
          "body": "Überprüfen Sie Ihre Zusammenfassung und validieren Sie mit einem Klick: Sie erhalten eine sofortige, transparente Schätzung basierend auf unseren aktuellen Rückkaufpreisen."
        },
        "3": {
          "title": "Versenden Sie Ihre Artikel",
          "body": "Drucken Sie das Etikett, packen Sie nach unseren Tipps und lassen Sie das Paket beim angegebenen Träger fallen. Tracking ist in Ihrem Konto verfügbar."
        },
        "4": {
          "title": "Teileprüfung",
          "body": "Bei der Ankunft überprüfen unsere Techniker jede Referenz, validieren ihren Zustand und veröffentlichen einen detaillierten Bericht (konform/nicht-konform) direkt in Ihrem Dashboard."
        },
        "5": {
          "title": "Erhalten Sie Ihre Zahlung",
          "body": "Sobald die Inspektion genehmigt ist, lösen wir sofort die Überweisung an Ihre IBAN aus. Keine versteckten Gebühren, kein Warten."
        }
      },
      "bottom": {
        "p1": {
          "s1": "mit",
          "bold1": "123Back",
          "s2": "profitieren Sie von einer einfachen, reibungslosen und vollständig nachvollziehbaren Rückkaufsreise. Die Auswahl der Teile, die sofortige Schätzung, der sichere Versand und die Expertenprüfungen folgen einander in einem klaren Prozess, der in Echtzeit in Ihrem Konto verfolgt wird. Unsere Priorität ist es, Ihnen zu helfen",
          "bold2": "Sparen Sie Zeit",
          "s3": "und",
          "bold3": "Sichern Sie sich Ihre Margen",
          "s4": "durch die Abwicklung von Logistik, Berichterstattung und Zahlung, während Sie die Kontrolle über Ihre Volumina und Preise haben."
        },
        "p2": {
          "s1": "Sie profitieren von",
          "bold1": "faire Preise",
          "s2": ", ",
          "bold2": "Schnelle Zahlung",
          "s3": "und a",
          "bold3": "transparente Erfahrung",
          "s4": ", genau das, was Sie von einem zuverlässigen, professionellen Partner erwarten."
        }
      }
    }
  },
  "pt": {
    "parcours": {
      "title": "Uma viagem de 5 passos!",
      "steps": {
        "1": {
          "title": "Escolha suas ecrãs e peças",
          "body": "Acesse nosso catálogo, selecione suas referências (modelos, condições, quantidades) e adicione-as ao seu carrinho. A interface é projetada para ser rápida e evitar erros.",
          "cta": "Escolha as minhas partes"
        },
        "2": {
          "title": "Confirme o seu carrinho",
          "body": "Verifique o seu resumo e valide em um clique: você obtém uma estimativa instantânea e transparente com base em nossos preços de buyback atualizados."
        },
        "3": {
          "title": "Envie seus itens",
          "body": "Imprima o rótulo, empacote seguindo nossas dicas, e solte o pacote na transportadora indicada. O rastreamento está disponível em sua conta."
        },
        "4": {
          "title": "Inspecção das peças",
          "body": "Na chegada, nossos técnicos verificam cada referência, validam sua condição e publicam um relatório detalhado (conformidade/não conformidade) diretamente em seu painel."
        },
        "5": {
          "title": "Receba o seu pagamento",
          "body": "Uma vez aprovada a inspeção, acionamos imediatamente a transferência bancária para o seu IBAN. Sem taxas ocultas, sem esperar."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Com",
          "bold1": "123Back",
          "s2": ", você se beneficia de uma viagem de resgate simples, suave e totalmente rastreável. Selecionando peças, estimativa instantânea, transporte seguro e verificações de especialistas seguem um ao outro em um processo claro, rastreado em tempo real em sua conta. Nossa prioridade é ajudá-lo",
          "bold2": "economizar tempo",
          "s3": "e",
          "bold3": "proteger suas margens",
          "s4": "Manuseando logística, relatórios e pagamento, deixando-o no controle de seus volumes e preços."
        },
        "p2": {
          "s1": "Beneficia de",
          "bold1": "preços justos",
          "s2": ", ",
          "bold2": "pagamento rápido",
          "s3": "e a",
          "bold3": "experiência transparente",
          "s4": ", exatamente o que você espera de um parceiro profissional confiável."
        }
      }
    }
  },
  "cs": {
    "parcours": {
      "title": "Pětikroková cesta!",
      "steps": {
        "1": {
          "title": "Vyberte si obrazovky a části",
          "body": "Procházet náš katalog, vyberte své odkazy (modely, podmínky, množství) a přidejte je do košíku. Rozhraní je navrženo tak, aby bylo rychlé a zabránilo chybám.",
          "cta": "Vyberte si mé části"
        },
        "2": {
          "title": "Potvrďte svůj vozík",
          "body": "Zkontrolujte si shrnutí a potvrďte v jednom kliknutí: dostanete okamžitý, transparentní odhad na základě našich up- to- date cen zpětného odkupu."
        },
        "3": {
          "title": "Zašlete své položky",
          "body": "Vytiskněte štítek, balte podle našich tipů a položte zásilku na označený nosič. Sledování je k dispozici na vašem účtu."
        },
        "4": {
          "title": "Kontrola částí",
          "body": "Při příjezdu naši technici kontrolují každý odkaz, ověřují jeho stav a zveřejňují detailní zprávu (vyhovující / nevyhovující) přímo ve vaší palubní desce."
        },
        "5": {
          "title": "Přijmout platbu",
          "body": "Jakmile je kontrola schválena, okamžitě spustíme bankovní převod do IBAN. Žádné skryté poplatky, žádné čekání."
        }
      },
      "bottom": {
        "p1": {
          "s1": "S",
          "bold1": "123Back",
          "s2": ", těžíte z jednoduché, hladké a plně vystopovatelné cesty zpět. Výběr částí, okamžitý odhad, zabezpečené lodní kontroly a expertní kontroly sledují jeden druhého v jasném procesu, sledované v reálném čase na vašem účtu. Naší prioritou je vám pomoci.",
          "bold2": "ušetřit čas",
          "s3": "a",
          "bold3": "Zajistěte si okraje",
          "s4": "tím, že zpracovává logistiku, podávání zpráv a platby, a zároveň vás nechává pod kontrolou své objemy a ceny."
        },
        "p2": {
          "s1": "Máš z toho prospěch.",
          "bold1": "reálné ceny",
          "s2": ", ",
          "bold2": "rychlá platba",
          "s3": "a",
          "bold3": "transparentní zkušenosti",
          "s4": "Přesně to, co očekáváte od spolehlivého, profesionálního partnera."
        }
      }
    }
  },
  "nl": {
    "parcours": {
      "title": "Een 5 stappen reis!",
      "steps": {
        "1": {
          "title": "Kies uw schermen en onderdelen",
          "body": "Blader door onze catalogus, selecteer uw referenties (modellen, voorwaarden, hoeveelheden) en voeg ze toe aan uw winkelwagen. De interface is ontworpen om snel te zijn en fouten te voorkomen.",
          "cta": "Kies mijn onderdelen"
        },
        "2": {
          "title": "Bevestig uw winkelwagen",
          "body": "Controleer uw samenvatting en valideer met één klik: u krijgt een directe, transparante schatting op basis van onze actuele inkoopprijzen."
        },
        "3": {
          "title": "Verzend uw items",
          "body": "Druk het etiket af, pak onze tips en laat het pakket vallen op de aangegeven drager. Tracking is beschikbaar in uw account."
        },
        "4": {
          "title": "Onderdeleninspectie",
          "body": "Bij aankomst controleren onze technici elke referentie, valideren ze de conditie en publiceren ze een gedetailleerd rapport (conform/niet-conform) direct in uw dashboard."
        },
        "5": {
          "title": "Ontvang uw betaling",
          "body": "Zodra de inspectie is goedgekeurd, activeren we onmiddellijk de overschrijving naar uw IBAN. Geen verborgen kosten, geen wachten."
        }
      },
      "bottom": {
        "p1": {
          "s1": "Met",
          "bold1": "123Back",
          "s2": ", u profiteert van een eenvoudige, soepele en volledig traceerbare terugkoop reis. Het selecteren van onderdelen, onmiddellijke schatting, veilige verzending, en deskundige controles volgen elkaar in een duidelijk proces, gevolgd in real time in uw account. Onze prioriteit is om u te helpen",
          "bold2": "tijd besparen",
          "s3": "en",
          "bold3": "Uw marges beveiligen",
          "s4": "door logistiek, rapportage en betaling te verwerken, terwijl u de controle over uw volumes en prijzen achterlaat."
        },
        "p2": {
          "s1": "U profiteert van",
          "bold1": "eerlijke prijzen",
          "s2": ", ",
          "bold2": "snelle betaling",
          "s3": "en a",
          "bold3": "transparante ervaring",
          "s4": ", precies wat je verwacht van een betrouwbare, professionele partner."
        }
      }
    }
  }
};

export default parcoursI18n;
